import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import MobileFilterBar from './MobileFilterBar';
import SearchResults from './SearchResults';
import FullScreenPanel from '../FullScreenPanel';

import styles from './styles.js';

class SearchContent extends Component {
    static propTypes = {
        contentLoading: PropTypes.bool.isRequired,
        filterGroupCollections: PropTypes.array.isRequired,
        getActiveFilters: PropTypes.number.isRequired,
        toggleFullScreenPanel: PropTypes.func.isRequired,
        user: PropTypes.object
    }

    state = {
        fullScreenPanel: {
            isVisible: false
        }
    }

    hideFullScreenPanel = () => {
        const { fullScreenPanel } = this.state;
        this.setState({
            fullScreenPanel: {
                ...fullScreenPanel,
                isVisible: false
            }
        });
    }

    showFullScreenPanel = () => {
        const { fullScreenPanel } = this.state;
        this.setState({
            fullScreenPanel: {
                ...fullScreenPanel,
                isVisible: true
            }
        });
    }

    render() {
        const { hideFullScreenPanel } = this;
        const { fullScreenPanel } = this.state;
        const {
            contentLoading,
            filterGroupCollections,
            getActiveFilters,
            toggleFullScreenPanel,
            user
        } = this.props;
        return (
            <div>
                <div className={css(styles.mobileFilterBarWrapper)}>
                    <MobileFilterBar
                        filterGroupCollections={filterGroupCollections}
                        getActiveFilters={getActiveFilters}
                        toggleFullScreenPanel={toggleFullScreenPanel}
                    />
                </div>
                <SearchResults
                    contentLoading={contentLoading}
                    user={user}
                />
                {
                    fullScreenPanel.isVisible ?
                        <FullScreenPanel
                            handleClose={hideFullScreenPanel}
                            // headingText={`Active Filters (${getActiveFilters})`}
                            withHeader
                            withFooter
                        /> : null
                }
            </div>
        );
    }
}

export default SearchContent;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/SearchContent.jsx